import { useEffect, useRef, useState } from 'react';
import useLogActivityAccess from '../hooks/useLogActivityAccess';
import './JogoPergunta.css';

// ── Sons ───────────────────────────────────────────────────
function playSound(src) {
  try { new Audio(src).play(); } catch {}
}

// ── Banco de perguntas ─────────────────────────────────────
const CATEGORIAS = [
  { id: 'prep',     label: 'Preposições',     icon: '📍' },
  { id: 'grammar',  label: 'Gramática',        icon: '📝' },
  { id: 'vocab',    label: 'Vocabulário',      icon: '📚' },
  { id: 'phrasal',  label: 'Phrasal Verbs',    icon: '💬' },
  { id: 'mix',      label: 'Misto',            icon: '🎲' },
];

const QUESTIONS = {
  prep: [
    { q: "Complete a frase: 'I'm __ work.'", a: ['at','in','on','over'], c: 0 },
    { q: "Complete a frase: 'The book is __ the table.'", a: ['up','at','on','in'], c: 2 },
    { q: "Complete a frase: 'The juice is __ the fridge.'", a: ['out','at','on','in'], c: 3 },
    { q: "Complete a frase: 'I wake up __ 6 o'clock.'", a: ['under','at','on','in'], c: 1 },
    { q: "Complete a frase: 'She was born __ September 1st.'", a: ['on','at','during','in'], c: 0 },
    { q: "Complete a frase: 'We go on a trip __ summer.'", a: ['up','at','on','in'], c: 3 },
    { q: "Complete a frase: 'The World War II began __ 1939.'", a: ['to','at','in','on'], c: 2 },
    { q: "Complete a frase: 'She lives __ New York.'", a: ['at','on','in','by'], c: 2 },
    { q: "Complete a frase: 'He goes to work __ bus.'", a: ['with','by','in','at'], c: 1 },
    { q: "Complete a frase: 'I'll see you __ Monday.'", a: ['in','at','on','by'], c: 2 },
    { q: "Complete a frase: 'The meeting is __ 3pm.'", a: ['on','by','at','in'], c: 2 },
    { q: "Complete a frase: 'She has lived here __ 2010.'", a: ['for','since','by','at'], c: 1 },
    { q: "Complete a frase: 'I've been waiting __ an hour.'", a: ['since','by','for','at'], c: 2 },
    { q: "Complete a frase: 'He is interested __ music.'", a: ['at','in','for','by'], c: 1 },
    { q: "Complete a frase: 'She is good __ math.'", a: ['in','on','at','for'], c: 2 },
    { q: "Complete a frase: 'I'm tired __ waiting.'", a: ['of','from','by','at'], c: 0 },
    { q: "Complete a frase: 'He arrived __ the airport at 5.'", a: ['in','at','on','by'], c: 1 },
    { q: "Complete a frase: 'We got married __ Valentine's Day.'", a: ['at','in','on','by'], c: 2 },
    { q: "Complete a frase: 'It happens __ the morning.'", a: ['on','at','in','by'], c: 2 },
    { q: "Complete a frase: 'She sat __ me at the cinema.'", a: ['beside','near','by','next to'], c: 3 },
    { q: "Complete a frase: 'He's afraid __ spiders.'", a: ['of','in','at','for'], c: 0 },
    { q: "Complete a frase: 'I depend __ my parents.'", a: ['of','on','in','at'], c: 1 },
    { q: "Complete a frase: 'She apologized __ being late.'", a: ['for','of','about','at'], c: 0 },
    { q: "Complete a frase: 'We arrived __ the hotel late.'", a: ['in','at','on','to'], c: 1 },
    { q: "Complete a frase: 'He's married __ a doctor.'", a: ['with','to','for','of'], c: 1 },
    { q: "Complete a frase: 'I'm looking __ my keys.'", a: ['for','at','of','to'], c: 0 },
    { q: "Complete a frase: 'She's allergic __ peanuts.'", a: ['for','to','with','of'], c: 1 },
    { q: "Complete a frase: 'The cat jumped __ the wall.'", a: ['over','in','on','at'], c: 0 },
    { q: "Complete a frase: 'He walked __ the room.'", a: ['into','at','on','by'], c: 0 },
    { q: "Complete a frase: 'I'll call you __ the morning.'", a: ['at','on','in','by'], c: 2 },
    { q: "Complete a frase: 'We live __ Lisbon.'", a: ['at','on','in','by'], c: 2 },
    { q: "Complete a frase: 'She's been studying __ 9am.'", a: ['for','since','by','at'], c: 1 },
    { q: "Complete a frase: 'He's proud __ his son.'", a: ['of','in','at','for'], c: 0 },
    { q: "Complete a frase: 'I agree __ you.'", a: ['with','to','for','at'], c: 0 },
    { q: "Complete a frase: 'The plane departs __ 10pm.'", a: ['on','in','at','by'], c: 2 },
  ],
  grammar: [
    { q: "Qual frase está correta?", a: ['She don\'t like it.','She doesn\'t like it.','She not like it.','She no like it.'], c: 1 },
    { q: "Qual é o passado de 'go'?", a: ['goed','goes','gone','went'], c: 3 },
    { q: "Complete a frase: 'He ___ to school every day.'", a: ['go','goes','going','gone'], c: 1 },
    { q: "Complete a frase: 'They ___ playing football now.'", a: ['is','are','am','be'], c: 1 },
    { q: "Complete a frase: 'I have ___ eaten.'", a: ['yet','just','still','ever'], c: 1 },
    { q: "Complete a frase: 'Have you finished ___?'", a: ['still','just','yet','already'], c: 2 },
    { q: "Complete a frase: 'She ___ here since Monday.'", a: ['is','was','has been','have been'], c: 2 },
    { q: "Complete a frase: 'By 2025, I ___ here for 5 years.'", a: ['will live','will have lived','have lived','lived'], c: 1 },
    { q: "Complete a frase: 'If I were rich, I ___ travel the world.'", a: ['will','would','should','could'], c: 1 },
    { q: "Complete a frase: 'The cake ___ by my mom.'", a: ['was made','made','is make','were made'], c: 0 },
    { q: "Complete a frase: 'He asked me where I ___.'", a: ['live','lives','lived','was living'], c: 2 },
    { q: "Complete a frase: 'She told me she ___ tired.'", a: ['is','was','were','be'], c: 1 },
    { q: "Qual frase está CORRETA?", a: ['She\'s home','She\'s at home','She\'s in home','She at home'], c: 1 },
    { q: "Qual frase está ERRADA?", a: ['She\'s in her house','She\'s at home','She\'s home','She\'s in home'], c: 3 },
    { q: "Complete a frase: 'I ___ to the gym three times a week.'", a: ['go','goes','going','am go'], c: 0 },
    { q: "Complete a frase: 'We ___ dinner when she called.'", a: ['had','were having','have had','have'], c: 1 },
    { q: "Escolha o comparativo correto:", a: ['gooder','more better','better','betterer'], c: 2 },
    { q: "Escolha o superlativo correto:", a: ['most biggest','the biggest','the most big','bigest'], c: 1 },
    { q: "Complete a frase: 'She is the ___ student in the class.'", a: ['most intelligent','intelligentest','more intelligent','intelligenter'], c: 0 },
    { q: "Complete a frase: 'Neither John ___ Mary came.'", a: ['or','nor','and','but'], c: 1 },
    { q: "Complete a frase: 'She ___ a book when I arrived.' (estava lendo)", a: ['reads','was reading','read','is reading'], c: 1 },
    { q: "Complete a frase: 'I wish I ___ more time.'", a: ['have','had','will have','having'], c: 1 },
    { q: "Qual é o plural de 'child'?", a: ['childs','children','childes','child\'s'], c: 1 },
    { q: "Qual é o plural de 'mouse'?", a: ['mouses','mices','mice','mouse\'s'], c: 2 },
    { q: "Complete a frase: 'This is the book ___ I told you about.'", a: ['who','which','whose','whom'], c: 1 },
    { q: "Complete a frase: 'If it ___ tomorrow, we'll stay home.'", a: ['rain','rains','will rain','rained'], c: 1 },
    { q: "Qual é a forma correta? 'She has ___ finished her homework.'", a: ['already','yet','still','ever'], c: 0 },
    { q: "Complete a frase: 'I'd rather ___ at home tonight.'", a: ['stay','staying','to stay','stayed'], c: 0 },
    { q: "Complete a frase: 'He suggested ___ a different approach.'", a: ['to try','trying','try','tried'], c: 1 },
    { q: "Qual frase usa o 'present perfect' corretamente?", a: ['I have seen that movie.','I saw that movie since.','I see that movie already.','I am seeing that movie yet.'], c: 0 },
    { q: "Complete a frase: 'There ___ many people at the party.'", a: ['was','were','is','be'], c: 1 },
    { q: "Complete a frase: 'I look forward to ___ from you.'", a: ['hear','hearing','heard','hears'], c: 1 },
    { q: "Qual é a forma correta do verbo 'to be' para 'he'?", a: ['am','is','are','be'], c: 1 },
    { q: "Complete a frase: 'You ___ smoke here, it's forbidden.'", a: ['mustn\'t','don\'t have to','can','should'], c: 0 },
    { q: "Complete a frase: 'She speaks English ___ she were a native speaker.'", a: ['if','when','as if','since'], c: 2 },
  ],
  vocab: [
    { q: "Qual é o sinónimo de 'happy'?", a: ['sad','glad','angry','tired'], c: 1 },
    { q: "Qual é o antônimo de 'cold'?", a: ['cool','warm','hot','mild'], c: 2 },
    { q: "'Enormous' significa:", a: ['tiny','huge','normal','strange'], c: 1 },
    { q: "Um 'sibling' é seu(sua):", a: ['friend','cousin','brother or sister','neighbour'], c: 2 },
    { q: "'Exhausted' significa:", a: ['happy','excited','very tired','confused'], c: 2 },
    { q: "Qual palavra significa 'escolher'?", a: ['lose','close','select','reject'], c: 2 },
    { q: "'Frequently' significa:", a: ['rarely','sometimes','never','often'], c: 3 },
    { q: "Um 'physician' é um(a):", a: ['teacher','lawyer','doctor','engineer'], c: 2 },
    { q: "'Commence' significa:", a: ['end','begin','continue','stop'], c: 1 },
    { q: "'Wealthy' significa:", a: ['sick','healthy','poor','rich'], c: 3 },
    { q: "O que significa 'purchase'?", a: ['sell','borrow','buy','throw'], c: 2 },
    { q: "'Cunning' descreve alguém que é:", a: ['kind','sly/clever','brave','shy'], c: 1 },
    { q: "O oposto de 'ancient' é:", a: ['old','modern','historic','classic'], c: 1 },
    { q: "'Obsolete' significa:", a: ['new','trendy','outdated','useful'], c: 2 },
    { q: "'Apologize' significa:", a: ['accuse','demand','say sorry','complain'], c: 2 },
    { q: "Um 'foe' é seu(sua):", a: ['friend','ally','enemy','partner'], c: 2 },
    { q: "'Genuine' significa:", a: ['fake','real/authentic','strange','valuable'], c: 1 },
    { q: "O que significa 'eager'?", a: ['bored','tired','enthusiastic','scared'], c: 2 },
    { q: "'Conceal' significa:", a: ['reveal','show','hide','find'], c: 2 },
    { q: "Uma 'decade' tem __ anos.", a: ['5','10','20','100'], c: 1 },
    { q: "O que significa 'cake'?", a: ['bread','dessert','soup','drink'], c: 1 },
    { q: "Qual é o sinónimo de 'beautiful'?", a: ['ugly','gorgeous','boring','plain'], c: 1 },
    { q: "Qual é o antônimo de 'expensive'?", a: ['costly','pricey','cheap','rich'], c: 2 },
    { q: "O que significa 'lazy'?", a: ['hardworking','tired','unwilling to work','strong'], c: 2 },
    { q: "'Furious' significa:", a: ['happy','calm','very angry','sad'], c: 2 },
    { q: "O que significa 'brilliant'?", a: ['dull','excellent','average','strange'], c: 1 },
    { q: "Qual é o sinónimo de 'difficult'?", a: ['easy','simple','hard','quick'], c: 2 },
    { q: "'Curious' significa:", a: ['bored','eager to know','angry','tired'], c: 1 },
    { q: "O que significa 'rude'?", a: ['polite','impolite','kind','shy'], c: 1 },
    { q: "Qual é o antônimo de 'generous'?", a: ['kind','selfish','rich','friendly'], c: 1 },
    { q: "'Stubborn' descreve alguém que é:", a: ['flexible','obstinate','calm','shy'], c: 1 },
    { q: "O que significa 'gorgeous'?", a: ['ugly','very beautiful','small','old'], c: 1 },
    { q: "Qual é o sinónimo de 'angry'?", a: ['furious','happy','calm','tired'], c: 0 },
    { q: "'Reliable' significa:", a: ['untrustworthy','dependable','lazy','dishonest'], c: 1 },
    { q: "O que significa 'ancient'?", a: ['modern','very old','new','recent'], c: 1 },
  ],
  phrasal: [
    { q: "Complete a frase: 'I need to ___ this problem.'", a: ['deal with','deal for','deal at','deal to'], c: 0 },
    { q: "Complete a frase: 'Don't give ___! Keep trying!'", a: ['in','up','out','away'], c: 1 },
    { q: "Complete a frase: 'I'll ___ you at the airport.' (buscar)", a: ['pick up','take up','carry on','bring in'], c: 0 },
    { q: "Complete a frase: 'She ___ her mom.' (se parece com)", a: ['takes after','looks after','gets on','looks up'], c: 0 },
    { q: "Complete a frase: 'They ___ the meeting until Friday.'", a: ['put off','put on','put out','put up'], c: 0 },
    { q: "Complete a frase: 'He ___ with a cold after the trip.'", a: ['came up','came down','came out','came in'], c: 1 },
    { q: "Complete a frase: 'Can you ___ the music? It's too loud.'", a: ['turn up','turn off','turn down','turn in'], c: 2 },
    { q: "Complete a frase: 'I need to ___ my shoes before entering.'", a: ['take off','take out','take up','take in'], c: 0 },
    { q: "Complete a frase: 'She wants to ___ Spanish next year.'", a: ['take up','take off','take on','take in'], c: 0 },
    { q: "Complete a frase: 'We ___ of petrol on the highway.'", a: ['ran out','ran away','ran off','ran into'], c: 0 },
    { q: "Complete a frase: 'I ___ an old friend at the mall.'", a: ['ran into','ran out','ran away','ran off'], c: 0 },
    { q: "Complete a frase: 'He ___ smoking last year.' (parou)", a: ['gave up','gave out','gave in','gave away'], c: 0 },
    { q: "Complete a frase: 'Please ___ this form.' (preencher)", a: ['fill in','fill up','fill out','all of these'], c: 3 },
    { q: "Complete a frase: 'She ___ the children while he works.'", a: ['looks after','looks up','looks for','looks at'], c: 0 },
    { q: "Complete a frase: 'I need to ___ before the meeting.' (se preparar)", a: ['brush up on','brush off','brush away','brush in'], c: 0 },
    { q: "Complete a frase: 'The fire ___. Nobody was hurt.'", a: ['went out','went off','went up','went on'], c: 0 },
    { q: "Complete a frase: 'He ___ a brilliant idea!'", a: ['came up with','came up to','came out with','came in with'], c: 0 },
    { q: "Complete a frase: 'I couldn't ___ what he was saying.' (entender)", a: ['make out','make off','make up','make for'], c: 0 },
    { q: "Complete a frase: 'She ___ to be a doctor.' (pretende)", a: ['looks up to','aims to be','looks forward to','is set on'], c: 3 },
    { q: "Complete a frase: 'You should ___ before making a decision.'", a: ['think it over','think it up','think it in','think it out'], c: 0 },
    { q: "Complete a frase: 'I'll ___ you up tomorrow morning.' (buscar de carro)", a: ['pick','take','bring','carry'], c: 0 },
    { q: "Complete a frase: 'She ___ down the offer.' (recusou)", a: ['turned','put','gave','took'], c: 0 },
    { q: "Complete a frase: 'We need to ___ up the room before guests arrive.' (organizar)", a: ['tidy','clean up','set','fix'], c: 1 },
    { q: "Complete a frase: 'He ___ out the lights before leaving.' (apagou)", a: ['turned off','turned out','put off','took off'], c: 0 },
    { q: "Complete a frase: 'I ___ up late on weekends.' (acordo)", a: ['wake','get','stand','rise'], c: 0 },
    { q: "Complete a frase: 'She ___ on her brother for help.' (depende)", a: ['relies','depends','counts','leans'], c: 1 },
    { q: "Complete a frase: 'They ___ off the trip due to bad weather.' (cancelaram)", a: ['called off','called out','called up','called in'], c: 0 },
    { q: "Complete a frase: 'He ___ in his resignation letter.' (entregou)", a: ['handed in','handed out','handed over','handed off'], c: 0 },
    { q: "Complete a frase: 'I can't ___ up with all this noise.' (suportar)", a: ['put','keep','take','stand'], c: 0 },
    { q: "Complete a frase: 'She ___ down for a nap.' (deitou-se)", a: ['lay','laid','lied','lain'], c: 0 },
    { q: "Complete a frase: 'We ___ into traffic on the way home.' (ficamos presos)", a: ['ran','got','hit','fell'], c: 1 },
    { q: "Complete a frase: 'He ___ up his mind to study abroad.' (decidiu)", a: ['made','set','put','took'], c: 0 },
    { q: "Complete a frase: 'Let's ___ over the details once more.' (revisar)", a: ['go','run','look','check'], c: 0 },
    { q: "Complete a frase: 'She ___ out of the meeting early.' (saiu)", a: ['walked','stepped','went','came'], c: 1 },
    { q: "Complete a frase: 'I ___ up smoking two years ago.' (desisti de)", a: ['gave','quit','stopped','left'], c: 0 },
  ],
};

// Gerar mix
function getMixQuestions() {
  const all = [...QUESTIONS.prep, ...QUESTIONS.grammar, ...QUESTIONS.vocab, ...QUESTIONS.phrasal];
  return shuffle(all).slice(0, 25);
}

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function getQuestions(catId) {
  if (catId === 'mix') return getMixQuestions();
  return shuffle(QUESTIONS[catId] || QUESTIONS.prep);
}

const KEYS = ['A', 'B', 'C', 'D'];
const LIVES_INIT = 3;
const TIMER_INIT = 30;
const LEVEL_UP_EVERY = 5;

// ── Componente ─────────────────────────────────────────────
export default function JogoPergunta() {
  useLogActivityAccess('jogo-pergunta');

  const [screen,    setScreen]    = useState('start');   // start | game | over
  const [catId,     setCatId]     = useState('prep');
  const [questions, setQuestions] = useState([]);
  const [qIndex,    setQIndex]    = useState(0);
  const [lives,     setLives]     = useState(LIVES_INIT);
  const [score,     setScore]     = useState(0);
  const [streak,    setStreak]    = useState(0);
  const [level,     setLevel]     = useState(1);
  const [timeLeft,  setTimeLeft]  = useState(TIMER_INIT);
  const [selected,  setSelected]  = useState(null);  // index escolhido
  const [feedback,  setFeedback]  = useState('');     // 'ok' | 'fail' | ''
  const [levelUp,   setLevelUp]   = useState(false);
  const [correct,   setCorrect]   = useState(0);      // total acertos
  const timerRef = useRef(null);

  const question = questions[qIndex];

  // ── Iniciar jogo ──────────────────────────────────────────
  function startGame() {
    const qs = getQuestions(catId);
    setQuestions(qs);
    setQIndex(0);
    setLives(LIVES_INIT);
    setScore(0);
    setStreak(0);
    setLevel(1);
    setCorrect(0);
    setSelected(null);
    setFeedback('');
    setLevelUp(false);
    setScreen('game');
  }

  // ── Timer ─────────────────────────────────────────────────
  useEffect(() => {
    if (screen !== 'game' || selected !== null) return;
    setTimeLeft(TIMER_INIT);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          handleTimeout();
          return 0;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [qIndex, screen]); // eslint-disable-line

  function handleTimeout() {
    playSound('/sound/disappointed.mp3');
    setFeedback('fail');
    setStreak(0);
    setSelected(-1); // sinaliza timeout
    setLives(prev => {
      const next = prev - 1;
      if (next <= 0) setTimeout(endGame, 1200);
      else setTimeout(nextQuestion, 1400);
      return next;
    });
  }

  // ── Selecionar resposta ───────────────────────────────────
  function selectAnswer(idx) {
    if (selected !== null) return;
    clearInterval(timerRef.current);
    setSelected(idx);

    const isCorrect = idx === question.c;
    if (isCorrect) {
      playSound('/sound/applause.mp3');
      setFeedback('ok');
      const newStreak  = streak + 1;
      const bonus      = newStreak >= 3 ? 2 : 1;
      setStreak(newStreak);
      setScore(s => s + bonus);
      setCorrect(c => c + 1);
      const newCorrect = correct + 1;
      if (newCorrect > 0 && newCorrect % LEVEL_UP_EVERY === 0) {
        playSound('/sound/level-up.mp3');
        setLevel(l => l + 1);
        setLevelUp(true);
        setTimeout(() => setLevelUp(false), 2500);
      }
      setTimeout(nextQuestion, 1200);
    } else {
      playSound('/sound/disappointed.mp3');
      setFeedback('fail');
      setStreak(0);
      setLives(prev => {
        const next = prev - 1;
        if (next <= 0) setTimeout(endGame, 1500);
        else setTimeout(nextQuestion, 1500);
        return next;
      });
    }
  }

  // ── Próxima pergunta ──────────────────────────────────────
  function nextQuestion() {
    setSelected(null);
    setFeedback('');
    setQIndex(i => {
      const next = i + 1;
      if (next >= questions.length) { endGame(); return i; }
      return next;
    });
  }

  function endGame() {
    clearInterval(timerRef.current);
    playSound('/sound/game-over.mp3');
    setScreen('over');
  }

  // ── Teclado ───────────────────────────────────────────────
  useEffect(() => {
    if (screen !== 'game') return;
    function onKey(e) {
      const map = { '1': 0, '2': 1, '3': 2, '4': 3 };
      if (map[e.key] !== undefined) selectAnswer(map[e.key]);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [screen, selected, question]); // eslint-disable-line

  const pct = questions.length ? ((qIndex) / questions.length) * 100 : 0;

  // ── Render: start ─────────────────────────────────────────
  if (screen === 'start') return (
    <div className="quiz-page">
      <div className="quiz-start">
        <div style={{ fontSize: '3.5rem', marginBottom: 8 }}>🎯</div>
        <h1>Quiz de Inglês</h1>
        <p>Escolha uma categoria e teste seu conhecimento!</p>

        <div className="quiz-category-grid">
          {CATEGORIAS.map(c => (
            <button
              key={c.id}
              className={`quiz-cat-btn${catId === c.id ? ' selected' : ''}`}
              onClick={() => setCatId(c.id)}
            >
              <span className="icon">{c.icon}</span>
              {c.label}
            </button>
          ))}
        </div>

        <button className="quiz-btn quiz-btn-green" onClick={startGame}>
          <i className="fas fa-play" /> Iniciar Jogo
        </button>
      </div>
    </div>
  );

  // ── Render: game over ─────────────────────────────────────
  if (screen === 'over') return (
    <div className="quiz-page">
      <div className="quiz-over">
        <div className="quiz-over-emoji">{lives > 0 ? '🏆' : '💔'}</div>
        <h2>{lives > 0 ? 'Parabéns!' : 'Fim de Jogo!'}</h2>
        <p>{lives > 0 ? 'Você completou todas as perguntas!' : 'Você perdeu todas as vidas.'}</p>

        <div className="quiz-stats-grid">
          <div className="quiz-stat-card">
            <div className="val">{correct}</div>
            <div className="lbl">Acertos</div>
          </div>
          <div className="quiz-stat-card">
            <div className="val">{score}</div>
            <div className="lbl">Pontos</div>
          </div>
          <div className="quiz-stat-card">
            <div className="val">{level}</div>
            <div className="lbl">Nível</div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="quiz-btn quiz-btn-green" onClick={startGame}>
            <i className="fas fa-redo" /> Jogar de novo
          </button>
          <button className="quiz-btn quiz-btn-ghost" onClick={() => setScreen('start')}>
            <i className="fas fa-home" /> Categorias
          </button>
        </div>
      </div>
    </div>
  );

  // ── Render: game ──────────────────────────────────────────
  if (!question) return null;

  // Embaralhar a ordem de exibição das opções (mapeando índice visual → índice real)
  return (
    <div className="quiz-page">
      <div className="quiz-card">

        {/* Status bar */}
        <div className="quiz-statusbar">
          <span className="quiz-stat lives">
            {Array.from({ length: LIVES_INIT }).map((_, i) => (
              <i key={i} className={`fas fa-heart${i < lives ? '' : '-broken'}`}
                 style={{ opacity: i < lives ? 1 : 0.3 }} />
            ))}
          </span>
          <span className="quiz-stat score"><i className="fas fa-star" /> {score}</span>
          <span className="quiz-stat level"><i className="fas fa-layer-group" /> Nv.{level}</span>
          {streak >= 2 && (
            <span className="quiz-stat streak"><i className="fas fa-fire" /> ×{streak}</span>
          )}
        </div>

        {/* Timer */}
        <div className="quiz-timer-wrap">
          <div className="quiz-timer-bar">
            <div
              className={`quiz-timer-fill${timeLeft <= 8 ? ' urgent' : ''}`}
              style={{ width: `${(timeLeft / TIMER_INIT) * 100}%` }}
            />
          </div>
          <div className="quiz-timer-label">{timeLeft}s</div>
        </div>

        {/* Progress */}
        <div className="quiz-progress">
          <div className="quiz-progress-bar">
            <div className="quiz-progress-fill" style={{ width: `${pct}%` }} />
          </div>
          <span className="quiz-progress-label">{qIndex + 1}/{questions.length}</span>
        </div>

        {/* Category badge */}
        <div className="quiz-cat-badge">
          {CATEGORIAS.find(c => c.id === catId)?.icon}{' '}
          {CATEGORIAS.find(c => c.id === catId)?.label}
        </div>

        {/* Level up */}
        {levelUp && (
          <div className="quiz-levelup">
            <div className="quiz-levelup-emoji">🎉</div>
            <div className="quiz-levelup-text">Nível {level}! Continue assim!</div>
          </div>
        )}

        {/* Question */}
        <div className="quiz-question">{question.q}</div>

        {/* Answers */}
        <div className="quiz-answers">
          {question.a.map((ans, i) => {
            let cls = '';
            if (selected !== null) {
              if (i === question.c)  cls = 'correct';
              else if (i === selected && i !== question.c) cls = 'wrong';
            }
            return (
              <button
                key={i}
                className={`quiz-answer-btn ${cls}`}
                onClick={() => selectAnswer(i)}
                disabled={selected !== null}
              >
                <span className="key">{KEYS[i]}</span>
                {ans}
              </button>
            );
          })}
        </div>

        {/* Feedback */}
        <div className={`quiz-feedback${feedback ? ` ${feedback}` : ''}`}>
          {feedback === 'ok'   && `✓ Correto! ${streak >= 3 ? `🔥 Combo ×${streak}!` : ''}`}
          {feedback === 'fail' && (selected === -1 ? '⏱ Tempo esgotado!' : `✗ Errado. Resposta: ${question.a[question.c]}`)}
        </div>

        {/* Skip button */}
        {selected === null && (
          <div style={{ textAlign: 'right', marginTop: 6 }}>
            <button className="quiz-btn quiz-btn-ghost" style={{ padding: '7px 14px', fontSize: '0.78rem' }}
                    onClick={() => { clearInterval(timerRef.current); handleTimeout(); }}>
              Pular <i className="fas fa-forward" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
